<template>
  <div class="body-div">
    <div class="main-nav styleCard">
      <ul class="style-nav style1">
        <li
          v-for="tab in timeTabs"
          :key="tab.id"
          class="router-link"
          @click="selectedTimeTab = tab.alias"
          :class="{ active: selectedTimeTab === tab.alias }"
        >
          {{ tab.name }}
        </li>
      </ul>
    </div>

    <div class="top-div" v-if="selectedTimeTab === 'TODAY'">
      <div class="table">
        <table
          v-if="
            Array.isArray(assignedAgents[0]) &&
              assignedAgents[0].length > 0 &&
              assignedAgents[0][0].total_in_time_frame > 0
          "
        >
          <thead>
            <tr class="text-center">
              {{
                GetTimeText("0")
              }}
              |
              {{
                assignedAgents[0][0].total_in_time_frame
              }}
            </tr>
          </thead>
          <tbody>
            <table v-for="user in assignedAgents[0]" :key="user.id">
              <tr>
                <td>
                  {{
                    salesPersonList.find(item => item.id === user.user_id)
                      .full_name
                  }}
                  | {{ user.conversion }} | {{ user.deposits }} |
                  {{ user.total }} | {{ user.total_in_time_frame }} |
                  {{
                    ((100 * user.total) / user.total_in_time_frame).toFixed(2)
                  }}%
                </td>
              </tr>
              <hr />
              <tr>
                <td v-for="cond in user.campaign_aaid" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ user.total_in_time_frame }} |
                    {{
                      ((100 * cond.amount) / user.total_in_time_frame).toFixed(
                        2
                      )
                    }}% |
                    {{ ((100 * cond.amount) / user.total).toFixed(2) }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in user.country_id" :key="cond.id">
                  <span
                    >{{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                    | {{ cond.amount }} | {{ user.total_in_time_frame }} |
                    {{
                      ((100 * cond.amount) / user.total_in_time_frame).toFixed(
                        2
                      )
                    }}% |
                    {{ ((100 * cond.amount) / user.total).toFixed(2) }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in user.keyword" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ user.total_in_time_frame }} |
                    {{
                      ((100 * cond.amount) / user.total_in_time_frame).toFixed(
                        2
                      )
                    }}% |
                    {{ ((100 * cond.amount) / user.total).toFixed(2) }}%</span
                  >
                </td>
              </tr>
              <hr />
            </table>
          </tbody>
        </table>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          assignedAgentsBusy[0] ||
            assignedAgentsBusy[1] ||
            assignedAgentsBusy[30] ||
            assignedAgentsBusy[90]
        "
      ></loader>
    </div>
    <div class="top-div" v-if="selectedTimeTab === 'YESTERDAY'">
      <div class="table">
        <table
          v-if="
            Array.isArray(assignedAgents[1]) &&
              assignedAgents[1].length > 0 &&
              assignedAgents[1][0].total_in_time_frame > 0
          "
        >
          <thead>
            <tr class="text-center">
              {{
                GetTimeText("1")
              }}
              |
              {{
                assignedAgents[1][0].total_in_time_frame
              }}
            </tr>
          </thead>
          <tbody>
            <table v-for="user in assignedAgents[1]" :key="user.id">
              <tr>
                <td>
                  {{
                    salesPersonList.find(item => item.id === user.user_id)
                      .full_name
                  }}
                  | {{ user.conversion }} | {{ user.deposits }} |
                  {{ user.total }} | {{ user.total_in_time_frame }} |
                  {{
                    ((100 * user.total) / user.total_in_time_frame).toFixed(2)
                  }}%
                </td>
              </tr>
              <hr />
              <tr>
                <td v-for="cond in user.campaign_aaid" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ user.total_in_time_frame }} |
                    {{
                      ((100 * cond.amount) / user.total_in_time_frame).toFixed(
                        2
                      )
                    }}% |
                    {{ ((100 * cond.amount) / user.total).toFixed(2) }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in user.country_id" :key="cond.id">
                  <span
                    >{{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                    | {{ cond.amount }} | {{ user.total_in_time_frame }} |
                    {{
                      ((100 * cond.amount) / user.total_in_time_frame).toFixed(
                        2
                      )
                    }}% |
                    {{ ((100 * cond.amount) / user.total).toFixed(2) }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in user.keyword" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ user.total_in_time_frame }} |
                    {{
                      ((100 * cond.amount) / user.total_in_time_frame).toFixed(
                        2
                      )
                    }}% |
                    {{ ((100 * cond.amount) / user.total).toFixed(2) }}%</span
                  >
                </td>
              </tr>
              <hr />
            </table>
          </tbody>
        </table>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          assignedAgentsBusy[0] ||
            assignedAgentsBusy[1] ||
            assignedAgentsBusy[30] ||
            assignedAgentsBusy[90]
        "
      ></loader>
    </div>
    <div class="top-div" v-if="selectedTimeTab === '30DAYS'">
      <div class="table">
        <table
          v-if="
            Array.isArray(assignedAgents[30]) &&
              assignedAgents[30].length > 0 &&
              assignedAgents[30][0].total_in_time_frame > 0
          "
        >
          <thead>
            <tr class="text-center">
              {{
                GetTimeText("30")
              }}
              |
              {{
                assignedAgents[30][0].total_in_time_frame
              }}
            </tr>
          </thead>
          <tbody>
            <table v-for="user in assignedAgents[30]" :key="user.id">
              <tr>
                <td>
                  {{
                    salesPersonList.find(item => item.id === user.user_id)
                      .full_name
                  }}
                  | {{ user.conversion }} | {{ user.deposits }} |
                  {{ user.total }} | {{ user.total_in_time_frame }} |
                  {{
                    ((100 * user.total) / user.total_in_time_frame).toFixed(2)
                  }}%
                </td>
              </tr>
              <hr />
              <tr>
                <td v-for="cond in user.campaign_aaid" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ user.total_in_time_frame }} |
                    {{
                      ((100 * cond.amount) / user.total_in_time_frame).toFixed(
                        2
                      )
                    }}% |
                    {{ ((100 * cond.amount) / user.total).toFixed(2) }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in user.country_id" :key="cond.id">
                  <span
                    >{{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                    | {{ cond.amount }} | {{ user.total_in_time_frame }} |
                    {{
                      ((100 * cond.amount) / user.total_in_time_frame).toFixed(
                        2
                      )
                    }}% |
                    {{ ((100 * cond.amount) / user.total).toFixed(2) }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in user.keyword" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ user.total_in_time_frame }} |
                    {{
                      ((100 * cond.amount) / user.total_in_time_frame).toFixed(
                        2
                      )
                    }}% |
                    {{ ((100 * cond.amount) / user.total).toFixed(2) }}%</span
                  >
                </td>
              </tr>
              <hr />
            </table>
          </tbody>
        </table>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          assignedAgentsBusy[0] ||
            assignedAgentsBusy[1] ||
            assignedAgentsBusy[30] ||
            assignedAgentsBusy[90]
        "
      ></loader>
    </div>
    <div class="top-div" v-if="selectedTimeTab === '90DAYS'">
      <div class="table">
        <table
          v-if="
            Array.isArray(assignedAgents[90]) &&
              assignedAgents[90].length > 0 &&
              assignedAgents[90][0].total_in_time_frame > 0
          "
        >
          <thead>
            <tr class="text-center">
              {{
                GetTimeText("90")
              }}
              |
              {{
                assignedAgents[90][0].total_in_time_frame
              }}
            </tr>
          </thead>
          <tbody>
            <table v-for="user in assignedAgents[90]" :key="user.id">
              <tr>
                <td>
                  {{
                    salesPersonList.find(item => item.id === user.user_id)
                      .full_name
                  }}
                  | {{ user.conversion }} | {{ user.deposits }} |
                  {{ user.total }} | {{ user.total_in_time_frame }} |
                  {{ (user.total / user.total_in_time_frame).toFixed(2) }}%
                </td>
              </tr>
              <hr />
              <tr>
                <td v-for="cond in user.campaign_aaid" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ user.total_in_time_frame }} |
                    {{
                      ((100 * cond.amount) / user.total_in_time_frame).toFixed(
                        2
                      )
                    }}% |
                    {{ ((100 * cond.amount) / user.total).toFixed(2) }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in user.country_id" :key="cond.id">
                  <span
                    >{{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                    | {{ cond.amount }} | {{ user.total_in_time_frame }} |
                    {{
                      ((100 * cond.amount) / user.total_in_time_frame).toFixed(
                        2
                      )
                    }}% |
                    {{ ((100 * cond.amount) / user.total).toFixed(2) }}%</span
                  >
                </td>
              </tr>
              <tr>
                <td v-for="cond in user.keyword" :key="cond.id">
                  <span
                    >{{ cond.id }} | {{ cond.amount }} |
                    {{ user.total_in_time_frame }} |
                    {{
                      ((100 * cond.amount) / user.total_in_time_frame).toFixed(
                        2
                      )
                    }}% |
                    {{ ((100 * cond.amount) / user.total).toFixed(2) }}%</span
                  >
                </td>
              </tr>
              <hr />
            </table>
          </tbody>
        </table>
      </div>

      <loader
        class="loader"
        :size="'8px'"
        v-if="
          assignedAgentsBusy[0] ||
            assignedAgentsBusy[1] ||
            assignedAgentsBusy[30] ||
            assignedAgentsBusy[90]
        "
      ></loader>
    </div>
    <div class="bottom-div" v-if="false">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >

      <loader :size="'11px'" v-if="assignedAgentsBusy"></loader>

      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
export default {
  name: "AssignedAgentsConversion.container",
  components: { Loader },
  data() {
    return {
      assignedAgentsBusy: {
        0: false,
        1: false,
        30: false,
        90: false
      },
      assignedAgents: {
        0: [],
        1: [],
        30: [],
        90: []
      },
      timeTabs: [
        {
          id: 0,
          name: "Today",
          alias: "TODAY"
        },
        {
          id: 1,
          name: "Yesterday",
          alias: "YESTERDAY"
        },
        {
          id: 2,
          name: "Last 30 Days",
          alias: "30DAYS"
        },
        {
          id: 3,
          name: "Last 90 Days",
          alias: "90DAYS"
        }
      ],
      selectedTimeTab: "TODAY"
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", [
      "dictionaries",
      "salesPersonList",
      "selectedStatisticsTimeFrameTab"
    ])
  },
  created() {
    this.getAssignedAgentsConversionByTimeFrame(0);
    this.getAssignedAgentsConversionByTimeFrame(1);
    this.getAssignedAgentsConversionByTimeFrame(30);
    this.getAssignedAgentsConversionByTimeFrame(90);

    this.selectedTimeTab = this.selectedStatisticsTimeFrameTab;
  },
  watch: {
    selectedTimeTab: function() {
      this.$store.commit(
        "clients/setSelectedStatisticsTimeFrameTab",
        this.selectedTimeTab
      );
    }

    // selectedStatisticsTimeFrameTab: function () {
    //   console.log(this.selectedStatisticsTimeFrameTab)
    //   this.selectedTimeTab = this.selectedStatisticsTimeFrameTab
    // }
  },
  methods: {
    async getAssignedAgentsConversionByTimeFrame(timeFrame) {
      if (
        !this.assignedAgentsBusy[timeFrame] &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.assignedAgentsBusy[timeFrame] = true;
          const res = await apiClientCreator(
            `reports/assigned_agents_conversion/${timeFrame}/true`
          ).get("");
          this.assignedAgents[timeFrame] = res.data;
          this.assignedAgents[timeFrame].sort((a, b) => {
            if (a.total > b.total) {
              return -1;
            }
            if (a.total < b.total) {
              return 1;
            }
            return 0;
          });
          this.assignedAgentsBusy[timeFrame] = false;
        } catch (e) {}
      }
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    GetTimeText(time) {
      if (time === "0") return "Today";
      if (time === "1") return "Yesterday";
      else return "Last " + time + " days";
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 4px 5px 1px 5px;
}
.top-div {
  height: 650px;
  overflow-y: scroll;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
}
.bottom-div {
  width: 100%;
  height: 650px;
  overflow-y: scroll;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
.table {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.table td {
  padding: 0.3em 0;
}
.table table {
  font-size: 13px;
  width: 1500px;
  margin: 3em 0;
}
.table thead {
  border-bottom: solid 2px #eff3f6;
}
.table tfoot {
  border-top: solid 2px #eff3f6;
  color: red;
}
.table th {
  text-align: center;
}
.text-center {
  font-weight: bold;
}
.loader {
  left: 0;
  right: 0;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
}
.style-nav .router-link {
  max-width: 150px;
  min-width: 72px;
  height: 28px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 11px;
  color: black;
  text-align: center;
  vertical-align: middle;
  line-height: 28px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.3s ease, color 0.3s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 .router-link:not(.empty):hover {
  background: #44a2d2;
  color: white;
  text-decoration: none;
}

.style-nav.style1 .router-link.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  text-decoration: none;
}
</style>
